import SubscribeForm from '@/components/feature/SubscribeForm';

export default function SubscribeSection() {
  return (
    <section id="subscribe" className="w-full bg-primary-950 py-12 md:py-16">
      <div className="container-page grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-14">
        <div>
          <span className="inline-flex items-center gap-1.5 rounded-full border border-primary-800 px-3 py-1 text-xs font-medium text-primary-200">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-notification-badge-line" aria-hidden="true" />
            </span>
            直播预告提醒
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-background-50 md:text-[32px]">
            不想错过重点场次，就让它来提醒你
          </h2>
          <p className="mt-4 max-w-lg text-sm leading-relaxed text-background-300">
            订阅后，我们会在当天重点场次开始前 30 分钟把场次名称、主播和看点发到你的邮箱。
            只推送排期提醒，不会转发任何广告内容，随时可以退订。
          </p>
          <ul className="mt-6 flex flex-col gap-3 text-sm text-background-200">
            {['每日重点场次一次汇总', '开播前 30 分钟准时提醒', '不转发广告，随时可退订'].map((text) => (
              <li key={text} className="flex items-center gap-2">
                <span className="w-4 h-4 flex items-center justify-center text-primary-300">
                  <i className="ri-check-double-line" aria-hidden="true" />
                </span>
                {text}
              </li>
            ))}
          </ul>
        </div>

        <SubscribeForm />
      </div>
    </section>
  );
}